<template>
  <div>
    <el-dialog
    width="420px"
    :visible='visible'
    :close-on-click-modal='false'
    :close-on-press-escape='false'
    :show-close='false'
    @close='closeDialog'

   >
    <template #title>
        <div class="edit_title">修改业务类型</div>
    </template>
    <el-form :model='edit_form' label-width="90px" :rules="rules" ref='edit_form'  v-loading='loading'>
        <el-form-item label="业务类型" prop="businessType">
             <el-select v-model="edit_form.businessType"  size="small" placeholder='请选择'>
                        <el-option
                            v-for="item in businessTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            >
                        </el-option>
                    </el-select>
        </el-form-item>
    </el-form>
    <template #footer>
            <div style="text-align:center"  >
                <el-button  @click="closeDialog" size="small" style="width:100px;">取消</el-button>
                <el-button  @click="edit" size="small"  style="width:100px;background:#269D7B;color:#fff">确定</el-button>
            </div>
    </template>
    </el-dialog>
  </div>
</template>

<script>
import {updateBankBusinessType,findBankBusinessType} from '@/api'
export default {
    data(){
        return {
            type:'',
            id:'',
            loading:false,
            businessTypeList:[],
            edit_form:{
                businessType:"",
            },
            rules:{
                businessType:[{ required: true, message: '请选择业务类型', trigger: 'change' }],
            },
            visible:false,
        }
    },
    methods:{
        /** 获取业务类型 */
        getAllType(){
            this.loading = true
            findBankBusinessType({type:this.type}).then(res=>{
                if(res.data.code==1){
                    this.businessTypeList = res.data.data
                }
            }).finally(()=>{
                this.loading = false
            })
        },
        handleOpen(row){
            this.id = row.id||''
            this.edit_form.businessType = row.fkBusinessTypeId || ''
            this.type = row.drcrf=='1'?0:1
            this.getAllType()
            this.visible = true
        },
        closeDialog(){
            this.type = ''
            this.edit_form.businessType=''
            this.$refs.edit_form.clearValidate();
            this.visible = false
        },
        edit(){
            this.$refs.edit_form.validate(valid=>{
                if(valid){
                    let params ={
                        id:this.id,
                        businessTypeId:this.edit_form.businessType
                    }
                    this.loading = true
                    updateBankBusinessType(params).then(res=>{
                        this.$message.success(res.data.msg)
                        this.$emit('editType')
                        this.closeDialog()
                    }).finally(()=>{
                        this.loading = false
                    })
                }
            })
        },
    },
}
</script>

<style scoped lang='less'>
.edit_title {
    font-size: 24px;
    margin-top: 10px;
    text-align: center;
    font-weight: bold;
    color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/editBussinessType.vue